import three from './assets/raj_1.png'
import one from './assets/raj_2.png'
import two from './assets/raj_3.jpg'

export default {
  pastCompanies: [one, two, three]
}
